<template>
  <div class="download-app">
    <h2 v-if="!onlyIcons" class="title">{{ $t("Download the Heed App") }}</h2>
    <p v-if="!onlyIcons" class="description">
      {{ $t("Get the full experience by using our mobile app.") }}
    </p>
    <p v-if="!onlyIcons">
      {{
        $t("Track your requests, receive real-time updates, and access all features straight from your phone.")
      }}
    </p>
    <div class="badges">
      <a
          :href="appStoreLink"
          target="_blank"
          rel="noopener"
          :aria-label="$t('Download on the App Store')"
      >
        <img
            v-if="$store.state.locale === 'el'"
            src="@/assets/images/appBadges/app_store_el.svg"
            :alt="$t('Download on the App Store')"
            class="badge"
        />
        <img
            v-else
            src="@/assets/images/appBadges/app_store_en.svg"
            :alt="$t('Download on the App Store')"
            class="badge"
        />
      </a>
      <a
          :href="playStoreLink"
          target="_blank"
          rel="noopener"
          :aria-label="$t('Get it on Google Play')"
      >
        <img
            v-if="$store.state.locale === 'el'"
            src="@/assets/images/appBadges/play_store_el.png"
            :alt="$t('Get it on Google Play')"
            class="badge"
        />
        <img
            v-else
            src="@/assets/images/appBadges/play_store_en.png"
            :alt="$t('Get it on Google Play')"
            class="badge"
        />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "DownloadApp",
  props: {
    appStoreLink: {
      type: String,
      required: true
    },
    playStoreLink: {
      type: String,
      required: true
    },
    onlyIcons: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.download-app {
  text-align: center;
  padding: 2rem;
  margin-top: 20px;
}
.title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
}
.badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.badge {
  height: 60px;
  transition: transform 0.2s ease;
}
.badge {
  display: flex !important;
}
.badge:hover {
  transform: scale(1.05);
}
</style>